import React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';

const navItems = ['Home', 'About', 'Contact'];

const DrawerComponent = (props) => {
	const { window } = props;
	const container = window !== undefined ? () => window().document.body : undefined;
	const drawerWidth = "25%";

	const drawer = (
		<Box onClick={props.handleDrawerToggle} style={{ textAlign: "center", width: "40rem" }}>
			<Typography variant="h6" style={{ my: 2 }}>
				Menu
			</Typography>
			<Divider />
			<List>
				{navItems.map((item) => (
					<ListItem key={item} disablePadding>
						<ListItemButton style={{ textAlign: "center" }}>
							<ListItemText primary={item} />
						</ListItemButton>
					</ListItem>
				))}
			</List>
		</Box>
	);

	return (
		<Box style={{ display: "flex", width: drawerWidth }} >
			<Box component="nav">
				<Drawer
					container={container}
					variant="temporary"
					open={props.mobileOpen}
					onClose={props.handleDrawerToggle}
					ModalProps={{
						keepMounted: true,
					}}
					style={{
						display: { xs: "block", sm: "none" },
						"& .MuiDrawerPaper": { boxSizing: "border-box", width: "100%" },
					}}
				>
					{drawer}
				</Drawer>
			</Box>
			<IconButton
				color="#1C1B1F"
				aria-label="open drawer"
				edge="end"
				onClick={props.handleDrawerToggle}
			>
				<MenuIcon />
			</IconButton>
		</Box>
	);
}

export default DrawerComponent;
